import $ from 'jquery';
import { trapFocus } from '../modules/slideoutFocusTrap';

/** Mobile menu hierarchy handling */
export default class MobileMenu {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;
    this.$element = $(element);

    this.menuStructure = JSON.parse(document.querySelector('#mobile-menu-data').textContent);
    this.themeMenuID = 'theme-menu';
    this.$topmenu = this.$element.find('#mobile-menu--main-menu');
    this.$menu = this.$element.find('#mobile-menu');
    this.$submenu = this.$element.find('#mobile-submenu');
    this.$topbarContainer = this.$element.find('#mobile-topbar');
    this.$element.find('.mobile-menu-sub').off('click').on('click', (e) => this.menuClick($(e.currentTarget), this.$menu));
    this.$element.find('.mobile-menu-back ').off('click').on('click', (e) => this.backClick($(e.currentTarget), this.$topmenu.children('li').children('.mobile-menu-link')));
    this.$lastClickedItem = null;
    this.handleTopbarLinks();

    if (window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', this.handleSectionLoad);
    }
  }

  handleSectionLoad = (e) => {
    const { sectionId } = e.detail;
    this.handleAnnouncementReload(sectionId);
  }

  handleAnnouncementReload = (sectionId) => {
    // Handle announcement bar mobile menu links when a menu is added/changed/removed
    if (sectionId != 'announcement-bar') return;
    this.handleTopbarLinks();
  }

  menuHandle = (handle) => {
    return this.menuStructure[handle];
  }

  removeAllMenuTabindex = () => {
    $('.mobile-menu').find('.mobile-menu-link').attr('tabindex', '-1');
  }

  setTabindex = (el, val) => {
    el.attr('tabindex', val);
    return;
  }

  makeLinksTabbable = ($activeMenu, trapFocus) => {
    this.removeAllMenuTabindex();

    if ( this.menuHasBackButton($activeMenu) ) this.setTabindex($activeMenu.children('.mobile-menu-back'), '0');

    if ( this.menuIsUl($activeMenu) ) this.setTabindex($activeMenu.children('li').children('.mobile-menu-link'), '0');

    if (this.menuHasUlChild($activeMenu) ) this.setTabindex($activeMenu.children('ul').children('li').children('.mobile-menu-link'), '0');

    if ( this.menuHasFieldsetChild($activeMenu) ) this.setTabindex($activeMenu.children('.mobile-menu__fieldset').children('.mobile-menu-link'), '0');

    trapFocus(this.themeMenuID);
  }

  menuIsUl = ($el) => {
    return $el.is('ul');
  }

  menuHasUlChild = ($el) => {
    return $el.children('ul').length;
  }

  menuHasBackButton = ($el) => {
    return $el.children('.mobile-menu-back');
  }

  menuHasFieldsetChild = ($el) => {
    return $el.children('.mobile-menu__fieldset').length;
  }

  menuClick = ($target, $menu) => {
    this.$lastClickedItem = $target;
    $('.mobile-menu.active').scrollTop(0);

    $('.mobile-menu').removeClass('active');
    var $menu_wrapper = $menu.closest('.mobile-menu');
    var handle = $target.data('link');

    $target.attr('aria-expanded', 'true');
    this.clearSubmenus($menu);

    if (handle === 'mobile-menu-currency' || handle === 'mobile-menu-locale') {
      $menu_wrapper = $(`#${handle}`);
      $menu_wrapper.removeClass('mobile-menu-hidden').addClass('active');
      this.makeLinksTabbable($menu_wrapper, trapFocus);

      return;
    }

    $menu_wrapper.addClass('active');

    var thisMenuHandle = this.menuHandle(handle);

    thisMenuHandle.links.forEach((link) => {
      var menu = this.menuHandle(link);

      var $li = $('<li></li>');
      if (menu.links.length > 0) {
        var $btn = $(`<button class="alt-focus mobile-menu-sub mobile-menu-link">${menu.title}<i data-feather="chevron-right" aria-hidden="true"></i></button>`)
          .attr('aria-expanded', 'false')
          .data('link', link)
          .on('click', (e) => {
            this.menuClick($(e.currentTarget), this.$submenu);
          });

        $li.append($btn);
      } else {
        var $a = $('<a class="alt-focus mobile-menu-link"></a>')
          .attr('href', menu.url)
          .html(menu.title);
        $li.append($a);
      }
      $menu.append($li);
    });

    $menu.find('.top-link')
      .text(thisMenuHandle.title)
      .attr('href', thisMenuHandle.url);

    var self = this;
    var insertChildNav = function() {
      var dfd = new $.Deferred();

      setTimeout(function() {
        $menu_wrapper.insertAfter($target)
          .find('.mobile-menu-back').off('click').on('click', (e) => self.backClick($(e.currentTarget), $target));
        dfd.resolve();
      }, 100);
      return dfd.promise();
    }

    insertChildNav().then(function() {
      self.makeLinksTabbable($menu_wrapper, trapFocus);

      $menu_wrapper.removeClass('mobile-menu-hidden');
    });

    this.theme.loadIcons();
  };

  clearSubmenus = ($menu) => {
    $menu.find('> li:not(:first)').remove();
  };

  handleTopbarLinks = () => {
    // Insert announcement bar menu links into mobile menu
    this.$topbarContainer.empty();
    const topbarTemplate = document.querySelector('[data-template-id="mobile-topbar"]');
    if (!topbarTemplate) return;
    const topbarFragment = topbarTemplate.content;
    const topbarClone = topbarFragment.cloneNode(true);
    this.$topbarContainer.append(topbarClone);
  }

  backClick = ($back_link, $parent_link) => {
    $('.mobile-menu').removeClass('active');
    $back_link.closest('.mobile-menu').addClass('mobile-menu-hidden');
    $parent_link.closest('.mobile-menu').addClass('active');

    $parent_link.attr('aria-expanded', false);
    this.makeLinksTabbable($parent_link.closest('.mobile-menu'), trapFocus);

    this.$lastClickedItem.focus();
  };
}
